import { SUCCESS } from '../../constants';
import { PREVIOUS_BOOKING, DELETE_PREVIOUS_BOOKING } from './action-types';

const initialState = {
  booking: undefined,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PREVIOUS_BOOKING + SUCCESS:
      return {
        ...state,
        booking: action?.payload?.response?.data?.data || undefined,
      };
    case DELETE_PREVIOUS_BOOKING: {
      return {
        ...state,
        booking: undefined,
      };
    }
    default:
      return state;
  }
};

export default reducer;
